/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindFaqByLanguageQueryResponse,
  FindFaqByLanguagePathParams,
} from "../types/FindFaqByLanguage.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findFaqByLanguageQueryKey = (
  lang: FindFaqByLanguagePathParams["lang"]
) => [{ url: "/v1/faq/:lang", params: { lang: lang } }] as const

export type FindFaqByLanguageQueryKey = ReturnType<
  typeof findFaqByLanguageQueryKey
>

/**
 * @summary Get all FAQ entries for a specific language
 * {@link /v1/faq/:lang}
 */
export async function findFaqByLanguage(
  lang: FindFaqByLanguagePathParams["lang"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindFaqByLanguageQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/faq/${lang}`, ...requestConfig })
  return res
}

export function findFaqByLanguageQueryOptions(
  lang: FindFaqByLanguagePathParams["lang"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findFaqByLanguageQueryKey(lang)
  return queryOptions<
    ResponseConfig<FindFaqByLanguageQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindFaqByLanguageQueryResponse>,
    typeof queryKey
  >({
    enabled: !!lang,
    queryKey,
    queryFn: async ({ signal }) => {
      return findFaqByLanguage(lang, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get all FAQ entries for a specific language
 * {@link /v1/faq/:lang}
 */
export function useFindFaqByLanguage<
  TData = ResponseConfig<FindFaqByLanguageQueryResponse>,
  TQueryData = ResponseConfig<FindFaqByLanguageQueryResponse>,
  TQueryKey extends QueryKey = FindFaqByLanguageQueryKey,
>(
  lang: FindFaqByLanguagePathParams["lang"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindFaqByLanguageQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findFaqByLanguageQueryKey(lang)

  const query = useQuery(
    {
      ...findFaqByLanguageQueryOptions(lang, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
